import { render } from "./RouterButton.vue?vue&type=template&id=7e3d220f"
import script from "./RouterButton.vue?vue&type=script&lang=js"
export * from "./RouterButton.vue?vue&type=script&lang=js"
script.render = render

export default script